


import React, { useState } from "react";

const gallery = [
  
 
   {
    id: 1,
    image: "images/fleet/3.jpeg",
  },
   {
    id: 1,
    image: "images/fleet/5.jpeg",
  },
   {
    id: 1,
    image: "images/fleet/7.jpeg",
  },
  
   {
    id: 1,
    image: "images/fleet/2.jpeg",
  },

   {
    id: 1,
    image: "images/fleet/4.jpeg",
  },
  
   {
    id: 1,
    image: "images/fleet/6.jpeg",
  },
       {
    id: 1,
    image: "images/fleet/1.jpeg",
  },
  
  {
    id: 1,
    name: "Honda Amaze",
    seats: "4 Seater",
    image: "images/fleet/Honda-Amaze.jpg",
  },

  {
    id: 2,
    name: "Hyundai Aura",
    seats: "4 Seater",
    image: "images/fleet/Hyundai-Aura.jpg",
  },

  {
    id: 3,
    name: "Hyundai Xcent",
    seats: "4 Seater",
    image: "images/fleet/Hyundai-Xcent.jpg",
  },

  {
    id: 4,
    name: "Swift Dzire",
    seats: "4 Seater",
    image: "images/fleet/Swift-Dzire.jpg",
  },

  {
    id: 5,
    name: "Toyota Etios",
    seats: "4 Seater",
    image: "images/fleet/Toyota-Etios.jpg",
  },

  {
    id: 6,
    name: "Toyota Corolla Altis",
    seats: "4 Seater",
    image: "images/fleet/Toyota-Corolla-Altis.jpg",
  },

  {
    id: 7,
    name: "Maruti Ertiga",
    seats: "7 Seater",
    image: "images/fleet/Maruti-Ertiga.jpg",
  },

  {
    id: 8,
    name: "Kia Carens",
    seats: "7 Seater",
    image: "images/fleet/Kia-Carens.jpg",
  },

  {
    id: 9,
    name: "Innova Crysta",
    seats: "7 Seater",
    image: "images/fleet/Innova-Crysta.jpg",
  },

  {
    id: 10,
    name: "Tourist Special Innova",
    seats: "7 Seater",
    image: "images/fleet/Tourist-Special-Innova.jpg",
  },

  {
    id: 11,
    name: "Scorpio",
    seats: "7 Seater",
    image: "images/fleet/Scorpio.jpg",
  },

  {
    id: 12,
    name: "Tempo Traveller",
    seats: "12-17 Seater",
    image: "images/fleet/Tempo-Traveller.jpg",
  },

  {
    id: 13,
    name: "Urbania Van",
    seats: "17 Seater",
    image: "images/fleet/Urbania.jpg",
  },

  {
    id: 14,
    name: "Mini Bus",
    seats: "30-50 Seater",
    image: "images/fleet/Mini-Bus.jpg",
  },
];
const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openImage = (index) => {
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === gallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? gallery.length - 1 : prev - 1
    );
  };

  return (
    <>
       <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1, }}></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Gallery</h1>
          </div>
        </div>
      </div>

      


      <div className="container py-5">
        <div className="row">
          {gallery.map((item, index) => (
            <div key={item.id} className="col-lg-4 col-md-6 mb-4">
              <div className="gallery-card borderr" onClick={() => openImage(index)}>
                <img src={item.image} alt={item.name} />
                <h5>{item.name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox">
          <span className="close darkcolorrrr  borderr" onClick={closeImage}>✖</span>

          <span className="prev" onClick={prevImage}>❮</span>
          <img
            src={gallery[currentIndex].image}
            alt="preview"
            className="lightbox-img "
          />
          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </>
  );
};

export default Gallery;